import { render } from "./AdditionalDetail.vue?vue&type=template&id=79902c8a"
import script from "./AdditionalDetail.vue?vue&type=script&lang=js"
export * from "./AdditionalDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__